import React from "react";

import { useTranslation } from "utils";

import { Button, Flex, Form, Link, Typography } from "components";

interface PasswordResetButtonsProps {
  loading: boolean;
}

export const PasswordResetButtons = ({ loading }: PasswordResetButtonsProps) => {
  const { t } = useTranslation("signinup");

  return (
    <Flex vertical gap={32}>
      <Typography variant="paragraph-m">
        <Link to="/sign-in" className="link green-text">
          {t("changePassword.buttons.signin")}
        </Link>
      </Typography>
      <Form.Item>
        <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
          {t("changePassword.title")}
        </Button>
      </Form.Item>
    </Flex>
  );
};
